























































import { Component } from "vue-property-decorator";
import { AuthService } from "@/services/auth/auth.service";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { Validate } from "vuelidate-property-decorators";
import { email, required } from "vuelidate/lib/validators";
import { i18n } from "@/resources/locales";
import moment from "moment";
@Component({})
export default class ConfirmInvitationView extends mixins(NotificationEvent) {
  @Validate({ required, email })
  email = "";
  @Validate({ required })
  name = "";
  loading = false;
  space = this.$route.params.space || "";
  type = this.$route.params.type || "";
  room = this.$route.query.room
    ? parseInt(this.$route.query.room as string, 10)
    : null;
  message = "";
  expirationTime = this.$route.query.expirationTime
      ? this.$route.query.expirationTime
      : null;
  mounted(): void {
    const { path } = this.$route;
    const roles = localStorage.getItem("roles") || [];
    if (roles && roles.includes("ROLE_SUPER_ADMIN")) {
      this.onError(
        "",
        this.$i18n.t("notifications.errorMessages.linkCannotBeUsed")
      );
      return;
    }

    if (path === "/active-guest") {
      /* Si viene por una invitacion personalizada de tipo guest */
      const { token, space, hasOnboarding, alwaysGrazing, room } =
        this.$route.query;
      this.type = "guest";
      this.message = i18n.t("confirmInvite.inviteGuest").toString();
      this.validateGuestData(token);
      localStorage.setItem("space_default", space.toString());
      localStorage.setItem("city", "OFF");
      localStorage.setItem(
        "hasOnboarding",
        hasOnboarding ? hasOnboarding.toString() : "true"
      );
      localStorage.setItem(
        "alwaysGrazing",
        alwaysGrazing ? alwaysGrazing.toString() : "false"
      );
      if (room) localStorage.setItem("room", room.toString());
      else localStorage.removeItem("room");
    } else {
      /* Si viene por un enlace rapido */
      const { type, token } = this.$route.params;
      const spaceId = this.$route.query.spaceId;
      const hasOnboarding = this.$route.query.hasOnboarding;
      const alwaysGrazing = this.$route.query.alwaysGrazing;
      const room = this.$route.query.room;

      localStorage.setItem(
        "hasOnboarding",
        hasOnboarding ? hasOnboarding.toString() : "true"
      );
      localStorage.setItem(
        "alwaysGrazing",
        alwaysGrazing ? alwaysGrazing.toString() : "false"
      );
      if (room) localStorage.setItem("room", room.toString());
      else localStorage.removeItem("room");
      if (spaceId) {
        localStorage.setItem("space_default", spaceId.toString());
        localStorage.setItem("city", "OFF");
      }
      if (type && token) {
        this.message =
          type == "user"
            ? i18n.t("confirmInvite.inviteUser").toString() + (this.expirationTime != null ? i18n.t("confirmInvite.expireOn") + moment(this.expirationTime).utc().format("DD-MM-yyyy HH:mm:ss"): "")
            : i18n.t("confirmInvite.inviteGuest").toString();

        switch (type) {
          case "user": {
            /* Si es una url publica de usuario */
            const localtoken = localStorage.getItem("token");
            const guestToken = localStorage.getItem("guestInvitationToken");
            const guestRefreshToken = localStorage.getItem(
              "guestInvitationRefreshToken"
            );
            if (guestToken && guestRefreshToken) {
              localStorage.clear();
              break;
            }
            if (localtoken) {
              //const jwtObject = JSON.parse(atob(localtoken.split(".")[1]));
              let email = localStorage.getItem("email");
              if (email) {
                let confirEmail = false;
                this.$store.dispatch(
                  "AuthStore/sendActivationUserEmailAction",
                  {
                    token,
                    data: {
                      email: email,
                      room: this.room,
                    },
                    callback: (response) => {
                      if (response.data.status === "OK") {
                        confirEmail = true;
                        this.onSuccess(
                          this.$i18n.t("notifications.titles.success"),
                          this.$i18n.t(
                            `notifications.apiMessage.${response.data.code}`
                          )
                        );
                      } else {
                        if (
                          response.data.code ===
                          "ERROR_USER_BELONG_SPACE_ALREADY"
                        )
                          this.onSuccess(
                            "",
                            this.$i18n.t(
                              `notifications.apiMessage.${response.data.code}`
                            )
                          );
                        else
                          this.onError(
                            this.$i18n.t("notifications.titles.error"),
                            this.$i18n.t(
                              `notifications.apiMessage.${response.data.code}`
                            )
                          );
                      }
                      if (confirEmail) {
                        this.$router.push("/send-confirmation").catch(() => {
                          // do nothing
                        });
                      } else {
                        //setTimeout(() => {
                        this.$router.push("/").catch((error) => {
                          // do nothing
                          // do nothing
                          window.location.reload();
                        });
                        //}, delay);
                      }
                      //this.$router.push("/send-confirmation").catch(() => {
                      // do nothing
                      //});
                    },
                    callbackError: () => {
                      this.loading = false;
                      this.onError(
                        this.$i18n.t("notifications.titles.error"),
                        this.$i18n.t(
                          "notifications.errorMessages.invitationExpired"
                        )
                      );
                    },
                  }
                );
              }
            }
            break;
          }
          case "guest": {
            /* si es una url publica de invitado */
            this.validateGuestData(token);
            break;
          }
          default: {
            this.$router.push("/").catch(() => {
              // do nothing
            });
            break;
          }
        }
      } else {
        this.$router.push("/").catch(() => {
          // do nothing
        });
      }
    }
  }
  validateGuestData(token) {
    const guestToken = localStorage.getItem("guestInvitationToken");
    const guestRefreshToken = localStorage.getItem(
      "guestInvitationRefreshToken"
    );
    const spaceToken = localStorage.getItem("space_token");
    if (guestToken && guestRefreshToken && spaceToken === token) {
      const _autService = new AuthService();
      _autService.decodeJwt({
        token: guestToken,
        refresh_token: guestRefreshToken,
      });
      this.$router.push("/").catch(() => {
        // do nothing
      });
    } else {
      //localStorage.clear();
    }
  }

  sendEmail(): void {
    const { path } = this.$route;
    this.loading = true;
    if (path === "/active-guest") {
      const { token } = this.$route.query;
      this.$store.dispatch("UserStore/activateGuestAction", {
        token,
        data: { name: this.name },
        callback: () => {
          this.loading = false;
          localStorage.setItem("space_token", token.toString());
          window.location.reload();
          return;
        },
        callbackError: (error) => {
          this.loading = false;
          if (error.data && error.data.status && error.data.status === "KO") {
            this.onError(
              this.$i18n.t("notifications.titles.error"),
              this.$i18n.t(`notifications.apiMessage.${error.data.code}`)
            );
            this.$router.push("/").catch(() => {
              // do nothing
            });
          } else {
            if (error.response.status == 400) {
              this.onError(
                this.$i18n.t("notifications.titles.error"),
                this.$i18n.t(
                  `notifications.apiMessage.${error.response.data.detail}`
                ),
                "none"
              );
            } else {
              this.onError(
                this.$i18n.t("notifications.titles.error"),
                this.$i18n.t("notifications.genericError.genericErrorRetry"),
                "none"
              );
            }
          }
        },
      });
    } else {
      const { type, token } = this.$route.params;
      if (type === "user") {
        /* Si viene por la url publica de usuario se envia el email */
        this.$store.dispatch("AuthStore/sendActivationUserEmailAction", {
          token,
          data: {
            email: this.email,
            room: this.room,
            expirationTime: this.expirationTime != null ? moment(this.expirationTime).utc().format("yyyy-MM-DD HH:mm:ss") : "",
            language: i18n.locale,
          },
          callback: (response) => {
            this.loading = false;
            if (response.data.status === "OK") {
              this.$router.push("/send-confirmation").catch(() => {
                // do nothing
              });
              return;
            } else {
              if (response.data.code === "ERROR_USER_BELONG_SPACE_ALREADY") {
                const localtoken = localStorage.getItem("token");
                if (localtoken) {
                  this.onSuccess(
                    "",
                    this.$i18n.t(
                      `notifications.apiMessage.${response.data.code}`
                    )
                  );
                } else
                  this.onSuccess(
                    "",
                    this.$i18n.t(
                      "notifications.apiMessage.ERROR_USER_BELONG_SPACE_ALREADY_NO_TOKEN"
                    )
                  );
              } else
                this.onError(
                  this.$i18n.t("notifications.titles.error"),
                  this.$i18n.t(`notifications.apiMessage.${response.data.code}`)
                );
            }
            this.$router.push("/").catch(() => {
              // do nothing
            });
          },
          callbackError: () => {
            this.loading = false;
            this.onError(
              this.$i18n.t("notifications.titles.error"),
              this.$i18n.t("notifications.errorMessages.invitationExpired")
            );
          },
        });
      } else {
        /*Si viene por la url publica de invitado se envia el nombre del usuario */
        localStorage.clear();
        this.$store.dispatch("AuthStore/loginGuestAction", {
          token,
          data: {
            name: this.name,
            room: this.room,
          },
          callback: () => {
            /*Recibio el token en la respuesta*/
            localStorage.setItem("space_token", token);
            window.location.reload();
            return;
          },
          callbackError: (response) => {
            this.loading = false;
            /* recibio un KO */
            if (response.data.status === "KO") {
              this.onError(
                this.$i18n.t("notifications.titles.error"),
                this.$i18n.t(`notifications.apiMessage.${response.data.code}`)
              );
              this.$router.push("/").catch(() => {
                // do nothing
              });
            }
          },
        });
      }
    }
  }
}
